// removed by extract-text-webpack-plugin
module.exports = {"itemContainer":"itemContainer__1qnPk","contentWrap":"contentWrap__ZDn6h","titleStyle":"titleStyle__34jQs","descriptionStyle":"descriptionStyle__TY0lZ","imgWrap":"imgWrap__3gMva","priceGroupWrap":"priceGroupWrap__1usQ4","btnWrap":"btnWrap__1brGb","pricetStyle":"pricetStyle__26t8B"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Live/styles.css
// module id = 1492
// module chunks = 0